export default {
  DEFAULT_ADD_FEATURE_NOTE:
    "Feature flag will be turned off by default when added. To enable edit in 'Settings'.",
  DEFAULT_ADD_APPLICATION_NOTE:
    "Default environments 'dev' and 'prod' will be created along with application",
  SETTINGS_ALL_ENV_NOTE:
    'Changes to these settings will impact this flag across all environments.',
  UNAUTHORIZED_SIGNOUT:
    'Session is expired or unauthorised. Please try to login again.',
  CONDITIONS: {
    TARGET_USER: {
      title: 'Add User Target Rule'
    },
    TARGET_APP_VERSION: {
      title: 'Add App Version Target Rule'
    }
  }
};
